import React, { useState } from "react"

import { Field, Form, Formik } from "formik"
import { buildMutation, compress, useMutation } from "micro-graphql-react"
import * as Yup from "yup"

import { ErrorMessage, RadioGroup, SubmitButton } from "components/Forms/Formik"

const ValidationSchema = Yup.object().shape({
  name: Yup.string().required(),
  hours: Yup.number().required(),
  price: Yup.number().required(),
  hourlyRate: Yup.number().required(),
})

const NewPrepaidPackage = () => {
  const [errorMessage, setErrorMessage] = useState()
  const formState = {
    name: "",
    hours: 0,
    price: 0,
    hourlyRate: 0,
    adminOnly: false,
    singleUse: false,
    amp: false,
  }

  const { runMutation } = useMutation(
    buildMutation(createPrepaidPackageMutation)
  )

  const handleSubmit = (values, actions) => {
    runMutation(values)
      .then(
        response => {
          actions.setSubmitting(false)
          if (response.errors) {
            setErrorMessage(JSON.stringify(response.errors))
          } else if (response.createPrepaidPackage.errorMessages) {
            setErrorMessage(
              response.createPrepaidPackage.errorMessages.join(", ")
            )
          } else {
            window.location.href =
              response.createPrepaidPackage.prepaidPackage.showPath
          }
        },
        err => {
          actions.setSubmitting(false)
          setErrorMessage("Something went wrong")
        }
      )
      .catch(err => {
        actions.setSubmitting(false)
        setErrorMessage("Something went wrong")
      })
  }

  return (
    <Formik
      initialValues={formState}
      onSubmit={handleSubmit}
      validationSchema={ValidationSchema}
    >
      {({ isSubmitting, values }) => (
        <Form>
          {errorMessage && (
            <div className="alert alert-danger">{errorMessage}</div>
          )}
          <div className="form-group">
            <label className="form-label">
              Name
              <Field name="name" className="form-control" />
              <ErrorMessage name="name" />
            </label>
          </div>

          <div className="form-group">
            <label className="form-label">
              Hours
              <Field name="hours" className="form-control" />
              <ErrorMessage name="hours" />
            </label>
          </div>

          <div className="form-group">
            <label className="form-label">
              Price
              <Field name="price" className="form-control" />
              <ErrorMessage name="price" />
            </label>
          </div>

          <div className="form-group">
            <label className="form-label">
              Hourly Rate
              <Field name="hourlyRate" className="form-control" />
              <ErrorMessage name="hourlyRate" />
            </label>
          </div>

          <div className="form-group">
            <RadioGroup
              type="checkbox"
              values={[
                {
                  value: true,
                  label: "Admin Only (clients will be unable to purchase)",
                },
              ]}
              name="adminOnly"
            />
          </div>

          <div className="form-group">
            <RadioGroup
              type="checkbox"
              values={[
                {
                  value: true,
                  label: "Single Use (clients may only purchase once)",
                },
              ]}
              name="singleUse"
            />
          </div>

          <div className="form-group">
            <RadioGroup
              type="checkbox"
              values={[{ value: true, label: "AMP" }]}
              name="amp"
            />
          </div>

          <SubmitButton isSubmitting={isSubmitting} />
        </Form>
      )}
    </Formik>
  )
}

const createPrepaidPackageMutation = compress`
  mutation(
    $name: String!
    $hours: String!
    $price: String!
    $hourlyRate: String!
    $adminOnly: Boolean!
    $singleUse: Boolean!
    $amp: Boolean!
  ) {
    createPrepaidPackage(
      name: $name
      hours: $hours
      price: $price
      hourlyRate: $hourlyRate
      adminOnly: $adminOnly
      singleUse: $singleUse
      amp: $amp
    ) {
      errorMessages
      prepaidPackage {
        showPath
      }
    }
  }
`

export default NewPrepaidPackage
